import React from 'react';
import CustomSimpleForm from './CustomSimpleForm';
import PropTypes from 'prop-types';

const SimpleFormWithSave = props => {
  const {
    onSave,
    save,
    saving,
    submitting,
    onKeyPress,
    ...simpleFormProps
  } = props;

  return (
    <CustomSimpleForm
      // We override the redux-form save prop to handle the submission ourselves
      save={onSave}
      saving={submitting ? submitting : undefined}
      onKeyPress={onKeyPress}
      {...simpleFormProps}
    />
  );
};

SimpleFormWithSave.propTypes = {
  onSave: PropTypes.func.isRequired,
  submitting: PropTypes.bool
};

export default SimpleFormWithSave;
